module.exports = __webpack_public_path__ + "img/logo-ticketshop.0b140e4c.png";